import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";



const store = configureStore({
  reducer: {
    auth: authSlice,

  },
});

export default store;

// INFO: Exporting auth actions and thunks
export {
  logout,
  switchRole,
  checkAndSwitchRoleByPath,
  openSignInModal, 
  closeSignInModal,
  handleSessionExpiration,
  endDataRefresh,
  startDataRefresh,
  updateAuth,
} from "./slices/authSlice";

export * from "./thunks/authThunks";
export * from "./thunks/userThunks";
export * from "./thunks/contactUsThunks";
